import { render, staticRenderFns } from "./QuestionItem.vue?vue&type=template&id=2eef2a34&scoped=true&"
import script from "./QuestionItem.vue?vue&type=script&lang=ts&"
export * from "./QuestionItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eef2a34",
  null
  
)

export default component.exports